import * as Yup from 'yup';

export const ProfileEditConfidentialInfoFormValidationSchema = Yup.object().shape(
  {
    PhoneNumber1: Yup.string()
      .nullable()
      .max(30, 'You have exceeded the maximum number of 30 characters')
      .required('Phone Number field is required'),

    PhoneNumber2: Yup.string()
      .nullable()
      .max(30, 'You have exceeded the maximum number of 30 characters'),

    EmailAddress2: Yup.string()
      .nullable()
      .email('Email address is incorrect')
      .max(100, 'You have exceeded the maximum number of 100 characters'),

    UndergraduateMajor: Yup.string()
      .nullable()
      .max(255, 'You have exceeded the maximum number of 255 characters'),

    GmatID: Yup.object()
      .nullable()
      .required('GMAT field is required'),

    GpaID: Yup.object()
      .nullable()
      .required('Undergraduate GPA field is required'),

    MathSatID: Yup.object()
      .nullable()
      .required('Math SAT field is required'),

    ScoreID: Yup.object()
      .nullable()
      .required('ACT Score field is required'),

    VerbalSatID: Yup.object()
      .nullable()
      .required('Verbal SAT field is required'),

    WritingSatID: Yup.object()
      .nullable()
      .required('Writing SAT field is required'),
  }
);
